import React from "react";

const Unauthorized = () => {
  return (
    <div className="h-screen flex items-center justify-center bg-red-100">
      <h1 className="text-3xl font-bold text-red-600">🚫 Access Denied</h1>
    </div>
  );
};

export default Unauthorized;